module.exports = __webpack_public_path__ + "static/2_1_search-2_BG-eb71f22d0c37853ed681e392deb696c7.svg";